<template>
  <div>
    <com-dialog :visible.sync="visible" title="编辑" width="30%">
      <template>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="110px"
          class="demo-ruleForm"
          v-loading="dialogLoading"
        >
          <el-form-item label="来源网点" prop="refRegisterStore">
            <el-select
              v-model="ruleForm.refRegisterStore"
              placeholder="输入网点名称搜索"
              filterable
              remote
              :remote-method="getSiteList"
              :loading="loading"
            >
              <el-option
                :label="item.name"
                :value="item.code"
                v-for="(item, index) in siteList"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="归属">
            <el-select
              v-model="ruleForm.refBelongAgent"
              placeholder="输入代理商名称搜索"
              filterable
              remote
              :remote-method="getAgentList"
              :loading="loading"
            >
              <el-option
                :label="item.name"
                :value="item.code"
                v-for="(item, index) in agentList"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="标签">
            <el-input v-model="ruleForm.tag" placeholder="输入用户标签"></el-input>
          </el-form-item>
          <div class="flex justify-end">
            <el-button @click="visible = false">取消</el-button>
            <el-button type="primary" @click="submitForm('ruleForm')">确认</el-button>
          </div>
          <el-form-item> </el-form-item>
        </el-form>
      </template>
    </com-dialog>
  </div>
</template>

<script>
import { partnersListApi } from '@/api/partners'
import { siteListApi } from '@/api/site'
import { editUser } from '@/api/user'

export default {
  data() {
    return {
      visible: false,
      type: '',
      loading: false,
      ruleForm: {
        code: '',
        refRegisterStore: '',
        refBelongAgent: '',
        tag: '',
      },
      rules: {
        refRegisterStore: [{ required: true, message: '请选择网点', trigger: 'blur' }],
      },
      agentList: [], // 代理商列表
      siteList: [], // 网点列表
      dialogLoading: false
    }
  },

  methods: {
    async open(row) {
      console.log('row :>> ', row)
      this.ruleForm.code = row.code
      this.visible = true
      this.dialogLoading = true

      await this.getSiteList(row.registerStore)
      await this.getAgentList(row.belongAgent)
      this.dialogLoading = false

      this.ruleForm.refRegisterStore = row.refRegisterStore
      this.ruleForm.refBelongAgent = row.refBelongAgentCode
      this.ruleForm.tag = row.tag
    },
    close() {
      this.visible = false
    },
    handleUpdate() {
      const params = { ...this.ruleForm }
      editUser(params).then(() => {
        this.$message.success('操作成功')
        this.$emit('success')
        this.visible = false
      })
    },
    submitForm(formName) {
      console.log('object :>> ', this.ruleForm)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.handleUpdate()
        }
      })
    },

    // 获取网点
    async getSiteList(value) {
      const param = {
        pageIndex: 1,
        pageSize: 10,
        name: value,
      }
      this.loading = true
     await siteListApi(param).then((res) => {
        this.siteList = res.data.records
        this.loading = false
      })
    },
    // 获取代理商
    async getAgentList(value) {
      const param = {
        pageIndex: 1,
        pageSize: 10,
        name: value,
        type: 3
      }
      this.loading = true
      await partnersListApi(param).then((res) => {
        this.agentList = res.data.records
        this.loading = false
        console.log('代理商列表', this.agentList)
      })
    },
  }
}
</script>

<style lang="scss" scoped></style>
